import { Auth0Client } from '@auth0/auth0-spa-js'
import { FoxtailWebConfig } from '../config/FoxtailWebConfig'

export const Auth0RawClient = new Auth0Client({
    domain: FoxtailWebConfig.config.auth0.domain,
    clientId: FoxtailWebConfig.config.auth0.clientId
})
